import React, { FC, createContext, useContext } from 'react'

import { BotUsageState, useBotUsage } from 'hooks/useBotUsage'

const BotUsageContext = createContext<BotUsageState | null>(null)

interface ProviderProps {
  botId: string | number
  enabled?: boolean
}

export const BotUsageProvider: FC<ProviderProps> = ({ botId, enabled = true, children }) => {
  const value = useBotUsage(botId, enabled)
  return <BotUsageContext.Provider value={value}>{children}</BotUsageContext.Provider>
}

export const useBotUsageContext = (): BotUsageState | null => useContext(BotUsageContext)

export default BotUsageContext
